import ArticleIcon from '@mui/icons-material/Article';
import { Box, CircularProgress, Paper, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import AppPaperContent from 'src/app/common/components/AppPaperContent';
import AppPaperTitle from 'src/app/common/components/AppPaperTitle';
import { getBlob } from 'src/app/common/network/crud/resourceCrud';
import { dispatch } from 'src/utils/eventBus/eventBus';
import { useBatchFilesViewPageContext } from '../../BatchFilesView.context';
import useStyles from './AdditionalInformation.styles';

const UploadedFile = () => {
  const intl = useIntl();
  const Translation = (id: string) => intl.formatMessage({ id });
  const { bdmSubmittedBatchFile } = useBatchFilesViewPageContext();
  const [isOpeningUrl, setIsOpeningUrl] = useState(false);
  const { classes } = useStyles();

  const openBlobUrl = async () => {
    if (!bdmSubmittedBatchFile?.document || isOpeningUrl) return;
    setIsOpeningUrl(true);
    try {
      const blob = (await getBlob({ resourceIds: bdmSubmittedBatchFile.document.blobId }, dispatch))?.[0];
      window.open(blob.url, '_blank', 'noopener,noreferrer');
    } catch (error) {
      // silently fail
    } finally {
      setIsOpeningUrl(false);
    }
  };

  return (
    <>
      <Typography variant="subtitle1" color="text.secondary" sx={{ mb: 1 }}>
        {Translation('opm_pd.uploadedFile')}
      </Typography>
      {!!bdmSubmittedBatchFile?.document ? (
        <div className={classes.uploadFileItem}>
          <ArticleIcon color="primary" />
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, overflow: 'hidden' }}>
            <Typography
              variant="body2"
              className={classes.uploadFileItemName}
              sx={{
                color: isOpeningUrl ? 'text.disabled' : 'primary.main',
                textDecoration: 'underline',
                cursor: isOpeningUrl ? 'default' : 'pointer',
              }}
              onClick={openBlobUrl}
            >
              {bdmSubmittedBatchFile?.document?.blobName}
            </Typography>
            {isOpeningUrl && <CircularProgress size={14} />}
          </Box>
        </div>
      ) : (
        <Typography variant="body2" color="text.secondary">
          {Translation('opm_pd.noFileUploaded')}
        </Typography>
      )}
    </>
  );
};

const AdditionalInformation = () => {
  const intl = useIntl();
  const Translation = (id: string) => intl.formatMessage({ id });
  const { bdmSubmittedBatchFile } = useBatchFilesViewPageContext();

  return (
    <Paper>
      <AppPaperTitle>{Translation('opm_pd.additionalInformation')}</AppPaperTitle>
      <AppPaperContent sx={{ pt: 0 }}>
        <UploadedFile />
        <TextField
          multiline
          fullWidth
          value={bdmSubmittedBatchFile?.notes || ''}
          inputProps={{ readOnly: true }}
          label={Translation('opm_pd.note')}
          variant="outlined"
          sx={{ mt: 2 }}
        />
      </AppPaperContent>
    </Paper>
  );
};

export default AdditionalInformation;
